function MedflexFeedbackPage() {
  return <div>MEDFLEX</div>;
}

export default MedflexFeedbackPage;
